import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { applyBearerAuthHeader } from '../utils/auth-token';
import { isBearerAuthMode } from '../utils/auth-mode';
import { getApiBaseUrl } from '../utils/runtime-urls';

const currenPath = getApiBaseUrl();

export const omdApi = createApi({
  reducerPath: 'omd',
  baseQuery: fetchBaseQuery({
    baseUrl: currenPath,
    credentials: isBearerAuthMode() ? 'omit' : 'include',
    prepareHeaders: (headers) => {
      applyBearerAuthHeader(headers);
      return headers;
    },
    jsonContentType: 'application/json',
  }),
  tagTypes: [
    'methodOfReceptionList',
    'TonarRateConfigurationList',
    'NomenclatureTransfer',
    'comingNomenclature',
    'contractorLegal',
  ],
  endpoints: () => ({}),
});
